import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "n-form-splitter" }
const _hoisted_2 = { class: "n-form-splitter__label label-m" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "n-form-splitter__space" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "n-form-splitter__line" })
], -1)
const _hoisted_4 = { class: "n-form-splitter__actions label-m" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("svg", {
  width: "16",
  height: "10",
  viewBox: "0 0 16 10",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M11.3624 0.924542C11.6199 1.18203 11.6397 1.5872 11.4218 1.8674L11.3624 1.93469L4.21957 9.07755C3.96208 9.33504 3.55692 9.35485 3.27671 9.13697L3.20942 9.07755L0.352276 6.22041C0.0733299 5.94146 0.0733299 5.4892 0.352276 5.21026C0.609764 4.95277 1.01493 4.93296 1.29514 5.15084L1.36243 5.21026L3.7145 7.56176L10.3523 0.924542C10.6312 0.645596 11.0835 0.645596 11.3624 0.924542ZM15.6481 0.924542C15.9056 1.18203 15.9254 1.5872 15.7076 1.8674L15.6481 1.93469L8.50529 9.07755C8.22634 9.3565 7.77408 9.3565 7.49513 9.07755C7.23765 8.82006 7.21784 8.4149 7.43571 8.13469L7.49513 8.0674L14.638 0.924542C14.9169 0.645596 15.3692 0.645596 15.6481 0.924542Z",
    fill: "#3379D9"
  })
], -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Apply to Opened Tabs ")
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.label), 1),
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      (_ctx.applicable)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "n-form-splitter__apply",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('apply')))
          }, _hoisted_7))
        : _createCommentVNode("", true)
    ])
  ]))
}